import { connect } from 'react-redux';
import moment from 'moment';
import _sortBy from 'lodash/sortBy';

import Grid from './grid';

const mapStateToProps = state => ({
  channels: _sortBy(state.channels, ['logical_channel_number']),
  gridWidth:
    (moment(state.ux.endDate).diff(state.ux.beginDate, 'days') + 1) *
    24 *
    60 *
    state.ux.minutesPixelRatio,
});

export default connect(mapStateToProps, null)(Grid);
